import React, { useState, useEffect } from 'react';
import { useUser } from '@/contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import { Link,useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import apiRequest from "@/services/requests";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

const Header = () => {
const location = useLocation();
const { user, loading } = useUser();
const navigate = useNavigate();
const [isMenuOpen, setIsMenuOpen] = useState(false);
const [isAccountMenuOpen, setIsAccountMenuOpen] = useState(false);
const [openDropdown, setOpenDropdown] = useState(null);
const [openMobileDropdown, setOpenMobileDropdown] = useState(null);
const [notifOpen, setNotifOpen] = useState(false);
const [notifications, setNotifications] = useState([]);
const [unread, setUnread] = useState(0);

const navigationItems = [
{
label: 'Home',
path: '/',
icon: 'Home',
tooltip: 'Overview and progress tracking'
},
{
label: 'Job Matching',
path: '/job-matching',
icon: 'Target',
tooltip: 'Discover matching opportunities'
},

{
label: 'Applications',
path: '/applications',
icon: 'Briefcase',
tooltip: 'See all the applications sent on your behalf'
},

{
label: 'Interviews',
path: '/interviews',
icon: 'Video',
tooltip: 'See all your scheduled interviews'
},

{
label: 'Tools',
icon: 'Box',
tooltip: 'More features coming soon.',
// children: [
// {
// label: 'Career Assessment',
// path: '/career-assessment',
// icon: 'ClipboardList',
// tooltip: 'Evaluate your skills and interests'
// },
// {
// label: 'Career Pivot',
// path: '/career-pivot',
// icon: 'ClipboardList',
// tooltip: 'Pivot Careers'
// },
// ]
}
];


/* fetch on mount and when dropdown opens */
useEffect(() => {
(async () => {
const data  = await apiRequest.notificationHeader();
setNotifications(data.list);
setUnread(data.unreadCount);
})();
}, []);


const openNotif = async () => {
setNotifOpen(p => !p);
if (!notifOpen && unread > 0) {
await apiRequest.notificationUpdate();
setUnread(0);
}
};





const isActive = (path) => location?.pathname === path;

const toggleMobileMenu = () => {
setIsMenuOpen(!isMenuOpen);
};

const toggleAccountMenu = () => {
setIsAccountMenuOpen(!isAccountMenuOpen);
};

const handleNavigation = (path) => {
// window.location.href = path;
navigate(path);
setIsMenuOpen(false);
};


const handleLogout = async () => {
setIsAccountMenuOpen(false);
try {
const response = await apiRequest.logout();
// Remove token from local storage
localStorage.clear();
navigate('/login'); // Redirect to the login page
} catch (error) {
toast.error('An unexpected error occurred', {
position: "bottom-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
progress: undefined,
});
}
};

if (loading) return;

return (
<header className="fixed top-0 left-0 right-0 z-50 bg-surface border-b border-border">
<div className="flex items-center justify-between h-16 px-6">
{/* Logo */}
<div className="flex items-center">
<div className="flex items-center space-x-2">
<Link className="flex-none rounded-xl text-xl inline-block font-semibold focus:outline-hidden focus:opacity-80" to="/" aria-label="Aplini">

<img src="/assets/images/aplini-logo.webp" className="w-28 h-auto" width="116" height="32"/>
</Link>
</div>
</div>

{/* Desktop Navigation */}
<nav className="hidden md:flex items-center space-x-8">
{navigationItems.map((item) => {

if (item.children) {
return (
<div key={item.label} className="relative">
<button
onClick={() =>
setOpenDropdown(openDropdown === item.label ? null : item.label)
}
className="flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium text-text-secondary hover:text-text-primary hover:bg-muted"
>
<Icon name={item.icon} size={20} />
<span>{item.label}</span>
<Icon name="ChevronDown" size={16} />
</button>

{openDropdown === item.label && (
<div className="absolute top-full mt-2 w-56 bg-popover border border-border rounded-md shadow-elevation-2 z-50">
{item.children.map((child) => (
<button
key={child.path}
onClick={() => handleNavigation(child.path)}
className={`w-full px-4 py-2 text-left text-sm hover:bg-muted flex items-center space-x-2 ${
isActive(child.path)
? 'text-primary bg-primary/10'
: 'text-text-secondary'
}`}
>
<Icon name={child.icon} size={16} />
<span>{child.label}</span>
</button>
))}
</div>
)}
</div>
);
}

return (
<button
key={item.path}
onClick={() => handleNavigation(item.path)}
className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium spring-transition ${
isActive(item.path)
? 'text-primary bg-primary/10'
: 'text-text-secondary hover:text-text-primary hover:bg-muted'
}`}
title={item.tooltip}
>
<Icon name={item.icon} size={20} />
<span>{item.label} 
{ item.label === 'Tools' && (<span className="text-red-500 text-[10px]">{'\n'}(Coming Soon)</span>) }
</span>
</button>
);
})}
</nav>


{/* Right Side Actions */}
<div className="flex items-center space-x-4">

{/* -------  Notifications  ------- */}
<div className="relative">
<Button variant="ghost" size="icon" onClick={openNotif}>
<Icon name="Bell" size={20} />
{unread > 0 && (
<span className="absolute -top-1 -right-1 bg-error text-error-foreground text-xs rounded-full w-5 h-5 flex items-center justify-center">
{unread}
</span>
)}
</Button>

{notifOpen && (
<>
<div className="fixed inset-0 z-40" onClick={() => setNotifOpen(false)} />

<div className="absolute right-0 top-full mt-2 w-56 bg-popover border border-border rounded-md shadow-elevation-2 z-50">
<div className="p-3 border-b border-border flex items-center justify-between">
<span className="text-sm font-medium">Notifications</span>
<Button variant="link" size="sm" onClick={() => navigate('/notifications')}>
See all
</Button>
</div>

<div className="divide-y divide-border">
{notifications.length === 0 && (
<div className="p-4 text-center text-sm text-muted-foreground">No new notifications</div>
)}

{notifications.map(n => (
<div
key={n.id}
className="p-3 hover:bg-muted cursor-pointer"
onClick={() => navigate('/applications')}
>
<div className="flex items-start justify-between">
<div>
<div className="text-sm font-medium">{n.type}</div>
<div className="text-xs text-muted-foreground mt-1">
{n.title} at {n.company}
</div>
</div>
<span className="text-xs text-muted-foreground">{dayjs(n.when).fromNow()}</span>
</div>
{!n.isRead && <div className="mt-1 w-2 h-2 bg-primary rounded-full" />}
</div>
))}
</div>
</div>
</>
)}
</div>



{/* Account Menu */}
<div className="relative">
<Button
variant="ghost"
size="icon"
onClick={toggleAccountMenu}
className="relative"
>
<Icon name="User" size={20} />
</Button>

{isAccountMenuOpen && (
<>
<div
className="fixed inset-0 z-40"
onClick={() => setIsAccountMenuOpen(false)}
/>
<div className="absolute right-0 top-full mt-2 w-56 bg-popover border border-border rounded-md shadow-elevation-2 z-50">
<div className="p-4 border-b border-border">
<p className="text-sm font-medium text-text-primary">{user?.personal.firstName} {user?.personal.lastName}</p>
<p className="text-xs text-text-secondary">{user?.personal.email}</p>
<span className="inline-block mt-1 py-1 bg-primary/10 text-primary text-xs rounded-full capitalize">
{user?.package.name} Package
</span>
</div>
<div className="py-2">
<button
onClick={() => navigate('/settings')}
className="w-full px-4 py-2 text-left text-sm text-text-primary hover:bg-muted spring-transition flex items-center space-x-2"
>
<Icon name="Settings" size={16} />
<span>Settings</span>
</button>
<button
onClick={() => navigate('/billing')}
className="w-full px-4 py-2 text-left text-sm text-text-primary hover:bg-muted spring-transition flex items-center space-x-2"
>
<Icon name="CreditCard" size={16} />
<span>Billing</span>
</button>
<button
onClick={() => navigate('/support')}
className="w-full px-4 py-2 text-left text-sm text-text-primary hover:bg-muted spring-transition flex items-center space-x-2"
>
<Icon name="HelpCircle" size={16} />
<span>Help & Support</span>
</button>
<button
onClick={() => navigate('/system-status')}
className="w-full px-4 py-2 text-left text-sm text-text-primary hover:bg-muted spring-transition flex items-center space-x-2"
>
<Icon name="HelpCircle" color={'red'} size={16} />
<span>System Status</span>
</button>
<hr className="my-2 border-border" />
<button
onClick={handleLogout}
className="w-full px-4 py-2 text-left text-sm text-destructive hover:bg-destructive/10 spring-transition flex items-center space-x-2"
>
<Icon name="LogOut" size={16} />
<span>Sign Out</span>
</button>
</div>
</div>
</>
)}
</div>

{/* Mobile Menu Button */}
<Button
variant="ghost"
size="icon"
className="md:hidden"
onClick={toggleMobileMenu}
>
<Icon name={isMenuOpen ? "X" : "Menu"} size={20} />
</Button>
</div>
</div>
{/* Mobile Navigation Menu */}
{isMenuOpen && (
<>
<div
className="fixed inset-0 bg-black/20 z-40 md:hidden"
onClick={() => setIsMenuOpen(false)}
/>
<div className="absolute top-full left-0 right-0 bg-surface border-b border-border shadow-elevation-2 z-50 md:hidden">
<nav className="py-4">
{navigationItems.map((item) => {
// TOOLS (has children)
if (item.children) {
const isOpen = openMobileDropdown === item.label;

return (
<div key={item.label} className="px-2">
<button
onClick={() =>
setOpenMobileDropdown(isOpen ? null : item.label)
}
className="w-full flex items-center justify-between px-4 py-3 text-left text-text-secondary hover:bg-muted rounded-md"
>
<div className="flex items-center space-x-3">
<Icon name={item.icon} size={20} />
<span className="text-sm font-medium">{item.label}</span>
</div>

<Icon
name="ChevronDown"
size={16}
className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
/>
</button>

{isOpen && (
<div className="ml-10 mt-1 space-y-1">
{item.children.map((child) => (
<button
key={child.path}
onClick={() => handleNavigation(child.path)}
className={`w-full flex items-center space-x-2 px-4 py-2 text-sm rounded-md ${
isActive(child.path)
? 'text-primary bg-primary/10'
: 'text-text-secondary hover:bg-muted'
}`}
>
<Icon name={child.icon} size={16} />
<span>{child.label}</span>
</button>
))}
</div>
)}
</div>
);
}

// NORMAL ITEMS
return (
<button
key={item.path}
onClick={() => handleNavigation(item.path)}
className={`w-full flex items-center space-x-3 px-6 py-3 text-left spring-transition ${
isActive(item.path)
? 'text-primary bg-primary/10 border-r-2 border-primary'
: 'text-text-secondary hover:text-text-primary hover:bg-muted'
}`}
>
<Icon name={item.icon} size={20} />
<div>
<span className="block text-sm font-medium">{item.label}
{ item.label === 'Tools' && (<span className="text-red-500 text-[12px]">{'\n'}(Coming Soon)</span>) }</span>
<span className="block text-xs text-text-secondary">{item.tooltip}</span>
</div>
</button>
);
})}

</nav>
</div>
</>
)}
</header>
);
};

export default Header;